export type CabinetStyle = {
  color: string
  imageUrl: string
  specification: string
  isComingSoon?: boolean
}

export const cabinetsData: CabinetStyle[] = [
  {
    color: 'Thielsen Pigeon White',
    imageUrl:
      'https://s3.amazonaws.com/musescabinets.com/products/sample-door/TPW.png',
    specification: `Framed Cabinet with Full Overlay Doors and Drawers
    Under Mount Full Extension Soft Close Drawer Glides
    Dovetail drawer, ¾” thick solid wood box sides
    Concealed European Style Hinges with Soft Close Feature
    Five-Piece Solid Wood Door with HDF Center Panel
    ½” Plywood Box with UV Coated Matching Exterior
    Glue & Staple or Metal Clip Assembly
    UV Coated Natural Interior`
  },
  {
    color: 'Thielsen Pebble Gray',
    imageUrl:
      'https://s3.amazonaws.com/musescabinets.com/products/sample-door/TPG.png',
    specification: `Framed Cabinet with Full Overlay Doors and Drawers
    Under Mount Full Extension Soft Close Drawer Glides
    Dovetail drawer, ¾” thick solid wood box sides
    Concealed European Style Hinges with Soft Close Feature
    Five-Piece Solid Wood Door with HDF Center Panel
    ½” Plywood Box with UV Coated Matching Exterior
    Glue & Staple or Metal Clip Assembly
    Cam Lock Assembly for older batches product
    UV Coated Natural Interior`
  },
  {
    color: 'Thielsen Sage Green',
    imageUrl:
      'https://s3.amazonaws.com/musescabinets.com/products/sample-door/TSG.png',
    specification: `Framed Cabinet with Full Overlay Doors and Drawers
    Under Mount Full Extension Soft Close Drawer Glides
    Dovetail drawer, ¾” thick solid wood box sides
    Concealed European Style Hinges with Soft Close Feature
    Five-Piece Solid Wood Door with HDF Center Panel
    ½” Plywood Box with UV Coated Matching Exterior
    Glue & Staple or Metal Clip Assembly
    UV Coated Natural Interior`
  },
  {
    color: 'Thielsen Sapphire Blue',
    imageUrl:
      'https://s3.amazonaws.com/musescabinets.com/products/sample-door/TSB.png',
    specification: `Framed Cabinet with Full Overlay Doors and Drawers
    Under Mount Full Extension Soft Close Drawer Glides
    Dovetail drawer, ¾” thick solid wood box sides
    Concealed European Style Hinges with Soft Close Feature
    Five-Piece Solid Wood Door with HDF Center Panel
    ½” Plywood Box with UV Coated Matching Exterior
    Glue & Staple or Metal Clip Assembly
    UV Coated Natural Interior`
  },
  {
    color: 'Thielsen Espresso',
    imageUrl:
      'https://s3.amazonaws.com/musescabinets.com/products/sample-door/TE.png',
    specification: `Framed Cabinet with Full Overlay Doors and Drawers
    Under Mount Full Extension Soft Close Drawer Glides
    Dovetail drawer, ¾” thick solid wood box sides
    Concealed European Style Hinges with Soft Close Feature
    Five-Piece Solid Wood Door with HDF Center Panel
    ½” Plywood Box with UV Coated Matching Exterior
    Glue & Staple or Metal Clip Assembly
    Cam Lock Assembly for older batches product
    UV Coated Natural Interior`
  },
  {
    color: 'Thielsen Primed Unfinished',
    imageUrl:
      'https://s3.amazonaws.com/musescabinets.com/products/sample-door/TPU.png',
    specification: `Framed Cabinet with Full Overlay Doors and Drawers
    Under Mount Full Extension Soft Close Drawer Glides
    Dovetail drawer, ¾” thick solid wood box sides
    Concealed European Style Hinges with Soft Close Feature
    Five-Piece Solid Wood Door with HDF Center Panel
    ½” Plywood Box with Primed Exterior ready for paint
    Glue & Staple or Metal Clip Assembly
    UV Coated Natural Interior`
  },
  {
    color: 'Atlanta White',
    imageUrl:
      'https://s3.amazonaws.com/musescabinets.com/products/sample-door/AW.png',
    specification: `Framed Cabinet with Full Overlay Doors and Drawers
    Under Mount Full Extension Soft Close Drawer Glides
    Dovetail drawer, ¾” thick solid wood box sides
    Concealed European Style Hinges with Soft Close Feature
    HDF Doors and Drawer Fronts
    ½” Plywood Box with UV Coated Matching Exterior
    Glue & Staple or Metal Clip Assembly
    UV Coated Natural Interior`
  },
  {
    color: 'Atlanta Onyx Black',
    imageUrl:
      'https://s3.amazonaws.com/musescabinets.com/products/sample-door/AOB.png',
    specification: `Framed Cabinet with Full Overlay Doors and Drawers
    Under Mount Full Extension Soft Close Drawer Glides
    Dovetail drawer, ¾” thick solid wood box sides
    Concealed European Style Hinges with Soft Close Feature
    HDF Doors and Drawer Fronts
    ½” Plywood Box with UV Coated Matching Exterior
    Glue & Staple or Metal Clip Assembly
    UV Coated Natural Interior`
  },
  {
    color: 'Rome Pigeon White',
    imageUrl:
      'https://s3.amazonaws.com/musescabinets.com/products/sample-door/RPW.png',
    specification: `Framed Cabinet with Full Overlay Doors and Drawers
    Under Mount Full Extension Soft Close Drawer Glides
    Dovetail drawer, ¾” thick solid wood box sides
    Concealed European Style Hinges with Soft Close Feature
    HDF Doors and Drawer Fronts
    ½” Plywood Box with UV Coated Matching Exterior
    Glue & Staple or Metal Clip Assembly
    UV Coated Natural Interior`
  },
  {
    color: 'Rome Heritage',
    imageUrl: '/cabinet-styles/rome-heritage.png',
    specification: `Framed Cabinet with Full Overlay Doors and Drawers
    Under Mount Full Extension Soft Close Drawer Glides
    Dovetail drawer, ⅝” thick solid wood box sides
    Concealed European Style Hinges with Soft Close Feature
    Solid Wood Door with Plywood Center Panel
    ½” Plywood Box with UV Coated Matching Exterior
    Glue & Staple or Metal Clip Assembly
    UV Coated Natural Interior`
  }
]
